<template>
	<div>
		<div class="page">
			<top />
			<div class="list">
				<div class="title">{{detail.ask_title}}</div>
				<div class="info flex">
					<img :src="imageUrl(detail.head_pic)" class="headimgurl" alt=""> {{detail.nickname}}
				</div>
				<div class="info flex">
					<span>时间 {{detail.add_time}}</span>
<!--          <span>阅读 {{detail.click}}</span>-->
				</div>
				<div class="deta">
					<div v-html="detail.content"></div>
				</div>
				<div class="message-box">
					<div class="fb-title">留言</div>
					<div class="message-wrap">
						<div class="message" v-for="(item,index) in apply_list">
							<div class="message-info">
								<div class="flex message-info-main">
									<span>
										<img :src="imageUrl(item.head_pic)" class="headimgurl">
										{{item.nickname}}</span>
									<span class="flex">
										<img style="width: 18px;margin-right: 5px;" v-if="item.is_like == 0"
											@click="clicklike(item.answer_id,index)" src="../../static/nolike.png"
											alt="">
										<img style="width: 18px;margin-right: 5px;"
											@click="clicklike(item.answer_id,index)" v-else src="../../static/like.png"
											alt="">
										<em>{{item.click_like}}</em>
									</span>
								</div>
							</div>
							<div class="message-content">
								<div class="message-text">
									<div v-html="item.content"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="pages">
					<el-pagination @current-change="handleCurrentChange" :current-page="page" :page-size="size"
						layout="total, prev, pager, next ,jumper" :pager-count="5" :total="count">
					</el-pagination>
				</div>
				<div class="message-box" style="margin-top: 40px;">
					<div class="fb-title">发表评论</div>
					<wangEditor v-model="wangEditorDetail" :isClear="isClear" :placeholder="`请输入正文`"
						@change="wangEditorChange">
					</wangEditor>
					<button class="message-btn btn-blue" @click="askapplyadd">发布</button>
				</div>
			</div>
			<info />
			<div style="width: 100%; height: 60px; background-color: #f6f6f6"></div>
			<foot />
		</div>
	</div>
</template>
<script>
	import top from "../../components/common/header.vue";
	import foot from "../../components/common/footer.vue";
	import info from "../../components/common/qrCode.vue";
	import wangEditor from "../../components/wangEditor.vue"
	import {
		askdetail,
		askapply_list,
		askapply_add,
		askapply_prize,
	} from "../../request/api";
	export default {
		components: {
			top,
			foot,
			info,
			wangEditor,
		},
		created() {
			this.alkid = this.$route.query.id
			this.getaskdetail()
			this.getaskapply_list()
		},
		data() {
			return {
				detail: '',
				count: 1,
				size: 20,
				page: 1,
				list: '',
				alkid: '',
				wangEditorDetail: "",
				apply_list: ''
			};
		},
		methods: {
			getaskdetail() {
				askdetail({
					id: this.alkid
				}).then((res) => {
					console.log(res);
					this.detail = res.data;
					document.title = '以图绘图印花设计网-' + res.data.ask_title;
				});
			},
			getaskapply_list() {
				askapply_list({
					ask_id: this.alkid,
					page: this.page
				}).then((res) => {
					console.log(res);
					this.apply_list = res.data.list;
					this.count = res.data.count
				});
			},
			askapplyadd() {
				var that = this
				var userInfo = localStorage.getItem("head_pic");
				if(!userInfo){
					this.$message({
						message: '请登录账号发布',
						type: "error",
					});
					return;
				}
				if (this.wangEditorDetail == '') {
					that.$message({
						message: '请输入内容',
						type: "error",
					});
					return false
				}
				askapply_add({
					ask_id: that.alkid,
					content: that.wangEditorDetail
				}).then((res) => {
					console.log(res);
					if (res.code == 200) {
						that.$message({
							message: "发布成功",
							type: "success",
						});
						that.wangEditorDetail = ''
						that.isClear = true
						that.detail.replies++
						that.page = 1
						that.getaskapply_list()
					} else {
						that.$message({
							message: res.msg,
							type: "error",
						});
					}
				});
			},
			clicklike(id, index) {
				askapply_prize({
					id: id
				}).then((res) => {
					if (this.apply_list[index].is_like == 0) {
						this.apply_list[index].is_like = 1
						this.apply_list[index].click_like++
					} else {
						this.apply_list[index].is_like = 0
						this.apply_list[index].click_like--
					}
				});
			},
			//公开区跳转
			goOpenArea(id) {
				console.log(id);
				this.$router.push({
					path: `/openArea/${id}`,
				});
			},
			//分页
			handleCurrentChange(val) {
				this.page = val;
				this.getaskindex();
			},
			//选项
			change(val) {
				this.page = 1;
				this.getaskindex();
			},
			wangEditorChange(val) {
				// console.log(val)
				this.wangEditorDetail = val.val
			},
		},
	};
</script>
<style lang="less">
	.page {
		background: #f6f6f6;
		height: auto;

		.list {
			padding: 0 15px;
			margin-top: 60px;
			min-height: 60vh;

			.title {
				font-size: 20px;
				line-height: 1.5;
				font-weight: bold;
			}

			.info {
				font-size: 15px;
				color: #999;
				margin: 20px 0;

				.headimgurl {
					width: 40px;
					height: 40px;
					margin-right: 10px;
					border-radius: 40px;
				}

				span {
					display: inline-block;
					margin-right: 15px;
				}
			}
		}

		.message-box {
			margin: 30px 0;

			.fb-title {
				font-size: 16px;
				margin-bottom: 20px;
			}

			.message {
				margin-bottom: 20px;
				align-items: flex-start;
			}

			.message-info {
				font-size: 16px;
				color: #999;
				margin: 20px 0;

				.message-info-main {
					justify-content: space-between;

					span {
						display: flex;
						align-items: center;
						margin-right: 10px;

						.headimgurl {
							width: 40px;
							height: 40px;
							margin-right: 10px;
							border-radius: 50%;
						}
					}
				}
			}

			.message-content {
				padding: 0 0 0 50px;

				.message-text {
					font-size: 14px;
					color: #666;
				}
			}
		}

		.message-btn {
			width: 100%;
			height: 40px;
			background-color: #317ADA;
			color: #fff;
			border: none;
			margin-top: 20px;
		}

		.flex {
			display: flex;
			align-items: center;
		}

		.pages {
			position: relative;
			left: -15%;
			transform: scale(0.7);
			margin-top: 20px;
		}
	}
</style>
